module.exports = __webpack_public_path__ + "static/img/img-071.3b0ac11.jpg";